function start(){
  var checkout_selectors = "input[name='checkout']:not(.hulkapps-ignore), input[value='Checkout']:not(.hulkapps-ignore), button[name='checkout']:not(.hulkapps-ignore), [href$='checkout']:not(.hulkapps-ignore), button[value='Checkout']:not(.hulkapps-ignore), input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'],.hulkapps_checkout"
  if(window.hulkapps.page_type == "product"){
    var variants = window.hulkapps.product.variants;
    window.hulkapps.product.selected_variant = null;
    window.product_page_btn_condition = function(){
      var options = [];
      var selector_var = document.querySelectorAll(".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio:checked, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']:checked");  
      selector_var.forEach(function(selector) {
        options.push(selector.value)
      });
      var grep = function(items, callback) {
          var filtered = [],
              len = items.length,
              i = 0;
          for (i; i < len; i++) {
              var item = items[i];
              var cond = callback(item);
              if (cond) {
                  filtered.push(item);
              }
          }
          return filtered;
      };
      options = grep(options, function(n){ return (n); });
      if (options.length == 1){
        var selected_variant_title = options;
      }else{
        var selected_variant_title = options.join(' / ');
      }
      var flag = 0;
      
      // Fluid Theme for getting Variant ID Start
      if(document.querySelector('.selected_variant span') != null){
          var variantId = document.querySelector('.selected_variant span').textContent;
        }else {
      // Fluid Theme for getting Variant ID End
      Object.keys(variants).forEach(function(key){
        var val = variants[key];
        selected_variant_title = selected_variant_title.toString().toLowerCase();
        var variantTitle = val.title.toString().toLowerCase();
        // if(variantTitle == selected_variant_title){
        if(selected_variant_title.includes(variantTitle)){
        var variantId = val.id;
        window.hulkapps.product.selected_variant = val.id
        }
      });
      }
    }
  }
  window.loadScript = function(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    // If the browser is Internet Explorer
    if (script.readyState){
      script.onreadystatechange = function() {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser
    } else {
      script.onload = function() {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  window.checkAppInstalled = function(version) {
  	window.hulkapps.is_volume_discount = true
  	window.hulkapps.is_product_option = false
  	if(window.hulkapps.is_product_option){
      loadScript(window.hulkapps.po_url+'/intl-tel-input.js', function() {
      	commonJS(version);
       cartPageJS(version);
       productPageJS(version);
     });
    }else{
      commonJS(version);
      cartPageJS(version);
      productPageJS(version);
    }
  };

  window.commonJS = function($){
    window.hulkappsDoActions = function(data) {
      if(data){
        if(data.discounts.discount_show){
          $(".discount_code_box").css("display","block");
        }

        if(data.discounts.plan){
          $(".edit_cart_option").css("display","block");
        }

        if (typeof data.discounts == "object" && typeof data.discounts.cart == "object" && typeof data.discounts.cart.items == "object") {
          hulkappsShowCartDiscounts(data.discounts)
        }
        
        if(data.discounts.is_draft_order){
          $(document).on('click', checkout_selectors, function(e){
            e.preventDefault();
            if (typeof hulkappsCheckout != "function") {
              window.location = "/checkout";
            }
            // Order Delivery Date App Code for validation issue
            if(typeof hulkappsCheckoutClick === 'undefined'){
              $(this).attr('disabled','disabled');
              hulkappsCheckout();
            }else{
              var result = hulkappsCheckoutClick();
              if(result == true){
                $(this).attr('disabled','disabled');
                hulkappsCheckout();
              }
            }
          });
        }
      }
    }
    window.hulkappsShowCartDiscounts = function(discounts) {
      window.hulkapps.discounts = discounts;
      var flag=0;
      discounts.cart.items.forEach(function(item) {
        if (item.cart_discount_away_msg_html){
          $(".hulkapps-reminder[data-key='" + item.key + "']").html(item.cart_discount_away_msg_html);
        }else{
          $(".hulkapps-reminder[data-key='" + item.key + "']").html('');
        }
        if (item.discounted_price < item.original_price) {
          flag=1;
          $(".hulkapps-cart-item-price[data-key='" + item.key + "']").html("<span class='original_price' style='text-decoration:line-through;'>" + item.original_price_format + "</span><br/>" + "<span class='discounted_price'>" + item.discounted_price_format + "</span>");
          $(".hulkapps-cart-item-line-price[data-key='" + item.key + "']").html("<span class='original_price' style='text-decoration:line-through;'>" + item.original_line_price_format + "</span><br/>" + "<span class='discounted_price'>" + item.discounted_line_price_format + "</span>")
        }else{
          $(".hulkapps-cart-item-price[data-key='" + item.key + "']").html("<span class='original_price'>" + item.original_price_format + "</span>");
          $(".hulkapps-cart-item-line-price[data-key='" + item.key + "']").html("<span class='original_price'>" + item.original_line_price_format + "</span>")
        }
      });
      $(".hulkapps-discount-bar").html('');
      $(".hulkapps-cart-total,.hulkapps-discount-reminder-msg").remove();
      $(".hulkapps-cart-original-total").css("text-decoration", "none");
      if(flag==1 || discounts.cart_discount_msg_html || discounts.is_draft_order){
        if(discounts.final_with_discounted_price == null && discounts.discounted_price_total != discounts.original_price_total){
          $(".hulkapps-cart-original-total").html(discounts.original_price_total).css("text-decoration", "line-through"); 
          $("<span class='hulkapps-cart-total'>" + discounts.discounted_price_total + "</span>").insertAfter('.hulkapps-cart-original-total');
        }else if(discounts.final_with_discounted_price != null){
          $(".hulkapps-cart-original-total").html(discounts.original_price_total).css("text-decoration", "line-through"); 
          $("<span class='hulkapps-cart-total'>" + discounts.final_with_discounted_price + "</span>").insertAfter('.hulkapps-cart-original-total');
        }
        if($(".hulkapps-discount-bar").length > 0){
          $(".hulkapps-discount-bar").html(discounts.cart_discount_msg_html)
        }else{
          $('form[action="/cart"]').prepend(discounts.cart_discount_msg_html)
        }
      }
      if(discounts.cart_discount_reminder_msg_html){
        if($(".hulkapps-cart-reminder").length > 0){
          $(".hulkapps-cart-reminder").html(discounts.cart_discount_reminder_msg_html)
        }else if($(".alert.hulkapps-discount-bar-msg").length > 0){
          $('.alert.hulkapps-discount-bar-msg').after(discounts.cart_discount_reminder_msg_html)
        }else{
          $('form[action="/cart"]').prepend(discounts.cart_discount_reminder_msg_html)
        }
      }
      $('.hulkapps_summary').remove();
      if (discounts.discount_code && discounts.discount_error == 1){
        $(".hulkapps-cart-original-total").html(discounts.original_price_total);
        $(".hulkapps_discount_hide").after("<span class='hulkapps_summary'>Discount code does not match</span>");
        localStorage.removeItem('discount_code');
      }else if (discounts.is_free_shipping){
        $(".hulkapps_discount_hide").after("<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>"+ discounts.discount_code +"<span class='close-tag'></span></span>Free Shipping");
      }else if(discounts.discount_code && $('.discount_code_box').is(":visible")){
        $(".hulkapps_discount_hide").after("<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>"+ discounts.discount_code +"<span class='close-tag'></span></span><span class='hulkapps_with_discount'>"+" -" + discounts.with_discount + "</span></span><span class='after_discount_price'><span class='final-total'>Total</span>"+discounts.final_with_discounted_price +"</span>");
        if(flag ==1 || discounts.cart_discount_msg_html){
          $(".hulkapps-cart-original-total").html(discounts.discounted_price_total).css("text-decoration", "line-through");
        }else{
          $(".hulkapps-cart-original-total").html(discounts.original_price_total).css("text-decoration", "line-through");
        }
        $(".hulkapps-cart-total").remove();
      }else{
        $(".hulkapps-cart-original-total").html(discounts.original_price_total);
        localStorage.removeItem('discount_code');
      }
    }
    window.hulkappsCheckout = function() {
      for (var i = 0; i < window.hulkapps.cart.items.length; i++) {
        var item = window.hulkapps.cart.items[i];
        var el = document.querySelectorAll("[id='updates_" + item.key + "']");
        if (el.length != 1) {
          el = document.querySelectorAll("[id='updates_" + item.variant_id + "']")
        }
        if (el.length == 1) {
          window.hulkapps.cart.items[i].quantity = el[0].value
        }
      }
      var pv_draft_url = '';
      if(window.hulkapps.is_volume_discount){
        pv_draft_url = window.hulkapps.vd_url+"/shop/create_draft_order";
      }else if(window.hulkapps.is_product_option){
        pv_draft_url = window.hulkapps.po_url+"/store/create_draft_order";
      }
      var storage_code = localStorage.getItem('discount_code');
      var ctags = window.hulkapps.customer ? window.hulkapps.customer.tags : '';
      $.getJSON('/cart.js', function(cart) {
        window.hulkapps.cart = cart;
        $.ajax({
          type: "POST",
          url: pv_draft_url,
          data: {cart_json: window.hulkapps,store_id: window.hulkapps.store_id, discount_code: storage_code,cart_collections: JSON.stringify(window.hulkapps.cart_collections),ctags: ctags},
          crossDomain: true,
          success: function(res) {
            if(typeof res == "string"){
              window.location.href = res
            }else{
              window.location.href = "/checkout"
            }
            localStorage.removeItem('discount_code');
          }
        });
      });
    }
    window.eligible_offer = function(data){
      var offer = data['eligible_offer'];
      var currency_symbol = data['store_currency']
      var p_id = data['p_id']
      var date_validate = data['is_date_validate']
      var charges_applied = data['charges_applied']
      var display = data['display_setting']
      var collection_object = data['collection_object']
      var level_html 
      // if (charges_applied && date_validate){
      if (charges_applied ){
        var level = JSON.parse(offer['offer_levels'])
        if (offer['display_offer_table_or_banner'] == 'grid'){
            var offer_layout_id = offer['offer_layout_id'] 
            return level_html = get_offer_table_layout(offer_layout_id, display, level, currency_symbol)
        }else if(offer['banner_msg']){
          var quantity, price, discount_type, discount, close_icon
          quantity = level[0][0]
          price = level[0][1]
          discount_type = level[0][2]
          discount = (discount_type == 'price_discount') ? currency_symbol+price+" "+display['off_text'] : (discount_type == 'fix_price') ?  display['get_at_text']+" "+price : price+"% "+display['off_text']
          close_icon = (offer['is_display_close_btn']) ? '<a href="javascript:void(0)" class="close_banner" style="position: absolute;top: 0;right: 0;padding: 5px 10px 5px;background: #cecece;font-size: 15px;">X</a>' : ''
         
          level_html = "<div class='alert hulkapps-banner-msg'>"+offer['banner_msg']+" "+close_icon+"</div><style>.hulkapps-banner-msg {font-size:"+offer['banner_font_size']+"px;color: "+offer['banner_font_color']+"; background-color: "+offer['banner_bg_color']+";min-height: 50px;padding: 6px 30px 6px 15px;position: relative; }"+display['custom_css']+"</style><script>"+display['custom_js']+"</script>"
          
          collection_object = (collection_object)? collection_object : ''
          return level_html = level_html.replace("{{qty}}", quantity ).replace("{{offer_type}}", collection_object+" "+offer['offer_type']).replace("{{discount}}", discount)
        }
      }else if(!charges_applied && data['eligible_offer']['offer_type']=="product"){
            var offer_layout_id = 1
            var level = JSON.parse(offer['offer_levels'])
            return level_html = get_offer_table_layout(offer_layout_id, display, level, currency_symbol)
      }else{
           return levels_html = ''
      }
    }
    window.get_offer_table_layout = function(offer_layout_id,display,level, currency_symbol){
      levels_html = ''
      if(offer_layout_id == 1 || offer_layout_id== 2 || offer_layout_id == 4){
        levels_html += "<div class='hulkapps-volume-discount-tiers'><table class='hulkapps-table table'><thead><tr><th>"+display['min_qty_text']+"</th><th>"+display['discount_text']+"</th></tr></thead><tbody>"
      }else{
        levels_html += "<div class='hulkapps-volume-discount-tiers'><table class='hulkapps-table table'><thead><tr><th>"+display['min_qty_text']+"</th><th>"+display['max_qty_text']+"</th><th>"+display['discount_text']+"</th></tr></thead><tbody>"
      }
      if(level.length > 0){
        var quantity, price, discount_type, discount
        $.each(level, function(key,value) {
          quantity = value[0]
          price = (display['include_decimal_in_offer_table'] ? value[1] : parseInt(value[1]))
          discount_type = value[2]
          if(offer_layout_id == 1){
            discount = (discount_type == 'price_discount') ? currency_symbol+price+" "+display['off_text'] : (discount_type == 'fix_price') ?  display['get_at_text']+" "+price : price+"% "+display['off_text']
            levels_html += "<tr><td>"+display['min_qty_before_text']+" "+quantity+" "+display['min_qty_after_text']+ "</td><td><span class='hulkapps-price'>"+discount+"</span></td></tr>"
          }else if(offer_layout_id == 2){
            discount = (discount_type == 'price_discount') ? currency_symbol+price : (discount_type == 'fix_price') ?  display['get_at_text']+" "+price : price+"%"
            levels_html += "<tr><td>"+quantity+ " "+display['min_qty_after_text']+"</td><td><span class='hulkapps-price'>"+discount+"</span></td></tr>"
          }else if(offer_layout_id == 3){
            discount = (discount_type == 'price_discount')? currency_symbol+""+price : ((discount_type == 'fix_price') ? display['get_at_text']+" "+ currency_symbol+""+price : price+"%")
            var second_qty = (quantity)? (level[key+1]) ? level[key+1][0] - 1 : '+' : ''
            levels_html += "<tr><td>"+quantity+"</td><td>"+ second_qty +"</td><td><span class='hulkapps-price'>"+discount+"</span></td></tr>" 
          }else if(offer_layout_id == 4){
            discount = (discount_type == 'price_discount')? currency_symbol+""+price : ((discount_type == 'fix_price') ? display['get_at_text']+" "+currency_symbol+""+price : price+"%")
            if(value == level[key-1]){
              levels_html += "<tr><td>"+quantity+" + " + "</td><td><span class='hulkapps-price'>"+discount+"</span></td></tr>"
            }else{
               var second_qty = (quantity)? (level[key+1]) ? level[key+1][0] - 1 : '+' : ''
              levels_html += "<tr><td>"+quantity+"-"+ second_qty+"</td><td><span class='hulkapps-price'>"+discount+"</span></td></tr>"
            }
          }
        });
      }
      levels_html += "</tbody></table></div><style>.hulkapps-table thead {background-color: "+display['header_bg_color']+";font-size: "+display['header_font_size']+"px;color: "+display['header_text_color']+";}.hulkapps-table tbody {background-color: "+display['body_bg_color']+";font-size: "+display['body_font_size']+"px;color: "+display['body_text_color']+"}.hulkapps-table th,.hulkapps-table td{border: "+display['grid_border_width']+"px solid "+display['border_color']+" !important;padding:8px 15px !important; }.hulkapps-table .hulkapps-price{color: "+display['discount_text_color']+"}.hulkapps-volumes {width: 100%;margin-top: 10px;}"+display['custom_css']+"</style><script>"+display['custom_js']+"</script>"
      return levels_html
    }
    window.hulkappsStart = function($) {
      window.hulkappsc = {};
      setTimeout(function() {
        window.hulkappsc.$first_add_to_cart_el = null;
        var selectors = ["input[name='add']", "button[name='add']", "#add-to-cart", "#AddToCartText", "#AddToCart"];
        var found_selectors = 0;
        selectors.forEach(function(selector) {
          found_selectors += $(selector).length;
          if (window.hulkappsc.$first_add_to_cart_el == null && found_selectors) {
            window.hulkappsc.$first_add_to_cart_el = $(selector).first()
          }
        });
        if (window.hulkapps.page_type == "product" && window.hulkappsc.$first_add_to_cart_el != null) {
          var vol_el_after = window.hulkappsc.$first_add_to_cart_el;
          if(vol_el_after.parent().is("div")) {
            vol_el_after = vol_el_after.parent()
          }
          if($(".hulkapps-volumes").length == 0){
            vol_el_after.after('<div class="hulkapps-volumes"></div>');
          }
          if($('#hulkapps_custom_options_'+window.hulkapps.product_id).length == 0){
            vol_el_after.before('<div id="hulkapps_custom_options_'+window.hulkapps.product_id+'"></div>');
          }
        }
        if(window.hulkapps.page_type == "product"){
          if(window.hulkapps.is_volume_discount){
            product_page_btn_condition();
            
            var selector_var = document.querySelectorAll(".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']:checked")
            selector_var.forEach(function(selector) {
              selector.addEventListener('change',(event) => {
                product_page_btn_condition();
                if(window.hulkapps.customer){
                  data = { pid : window.hulkapps.product_id, store_id : window.hulkapps.store_id, ctags: window.hulkapps.customer.tags, product_variants: window.hulkapps.product.selected_variant, product_collections: window.hulkapps.product_collections}
                }else{
                  data = { pid : window.hulkapps.product_id, store_id : window.hulkapps.store_id, product_variants: window.hulkapps.product.selected_variant, product_collections: window.hulkapps.product_collections}
                }
                $.ajax({
                    type:"POST",
                    url: window.hulkapps.vd_url+"/api/v2/shop/get_offer_table",
                    data : data,
                    crossDomain: true,
                    success:function(data){
                      if(data){
                        var html_text = eligible_offer(data)
                        writeCookie("vd_"+window.hulkapps.product_id,data,1);
                        $('.hulkapps-volumes').html(html_text);
                      }else{
                         $('.hulkapps-volumes').html("");
                      }
                      
                    }
                  });
              });
            });
            
            $(document).on('click', '.close_banner', function(event) {
              $('.hulkapps-banner-msg').remove();
            });
            if(window.hulkapps.customer){
              data = { pid : window.hulkapps.product_id, store_id : window.hulkapps.store_id, ctags: window.hulkapps.customer.tags, product_variants: window.hulkapps.product.selected_variant, product_collections: window.hulkapps.product_collections}
            }else{
              data = { pid : window.hulkapps.product_id, store_id : window.hulkapps.store_id, product_variants: window.hulkapps.product.selected_variant, product_collections: window.hulkapps.product_collections}
            }
            var offer_table = readCookie("vd_"+window.hulkapps.product_id);
            if(offer_table != '' && offer_table != null && typeof offer_table !== 'undefined'){
              $('.hulkapps-volumes').html(readCookie("vd_"+window.hulkapps.product_id));
            }else{
              $.ajax({
                type:"POST",
                url: window.hulkapps.vd_url+"/api/v2/shop/get_offer_table",
                data : data,
                crossDomain: true,
                success:function(data){
                  if(data){
                    var html_text = eligible_offer(data)
                    writeCookie("vd_"+window.hulkapps.product_id,data,1);
                    $('.hulkapps-volumes').html(html_text);
                  }else{
                    $('.hulkapps-volumes').html("");
                  }
                  
                }
              });
            } 
          }
        }
        // $("body").on("change", 'input[name="updates[]"]', function(ev) {
        //   $('[name="update"]').click();
        // });
      }, 1);

      if (window.hulkapps.page_type == "cart" && window.hulkapps.cart.item_count == 0){
        localStorage.removeItem('discount_code');     
      }
      
      if(window.hulkapps.page_type == "cart" && window.hulkapps.cart.items.length > 0){
        var pv_cart_url = '';
        if(window.hulkapps.is_volume_discount){
          pv_cart_url = window.hulkapps.vd_url+"/shop/get_cart_details";
        }else if(window.hulkapps.is_product_option){
          pv_cart_url = window.hulkapps.po_url+"/store/get_cart_details";
        }
        if(pv_cart_url != ''){
          var storage_code = localStorage.getItem('discount_code');
          // var cust_id = window.hulkapps.customer ? window.hulkapps.customer.id : '' 
          var ctags = window.hulkapps.customer ? window.hulkapps.customer.tags : '' 
          if (storage_code != ''){
            $('.hulkapps_discount_code').val(storage_code);
            // var get_cart_data = {cart_data: window.hulkapps,store_id: window.hulkapps.store_id, discount_code: storage_code, cart_collections: JSON.stringify(window.hulkapps.cart_collections),cid: cust_id}
            var get_cart_data = {cart_data: window.hulkapps,store_id: window.hulkapps.store_id, discount_code: storage_code, cart_collections: JSON.stringify(window.hulkapps.cart_collections), ctags: ctags}
          }else{
            var get_cart_data = {cart_data: window.hulkapps,store_id: window.hulkapps.store_id,cid: cust_id}
          }
          $(checkout_selectors).attr('disabled', true);
          $.ajax({
            type: "POST",
            url: pv_cart_url,
            data: get_cart_data,
            crossDomain: true,
            success: function(data){
              $(checkout_selectors).attr('disabled', false);
              hulkappsDoActions(data)
            },
            error: function (request, error) {
              $(checkout_selectors).attr('disabled', false);
            }
          });
        }
        $('body').on('click', '.edit_cart_option', function(e) {
          $('body').addClass('body_fixed');
          e.preventDefault();
          var key = $(this).data("key");
          var cart = window.hulkapps.cart;
          var store_id = window.hulkapps.store_id;
          var pid = $(this).data("product_id");
          var variant_id = $(this).data("variant_id");
          $("[name^='properties']").each(function(){
            if($(this).val() == ''){
              $(this).attr('disabled',true);
            }
          });
          $.ajax({
            type: 'POST',
            url: window.hulkapps.po_url+'/api/v2/store/edit_cart',
            data: { cart_data: cart ,item_key: key, store_id: store_id, variant_id: variant_id },
            cache: false,
            crossDomain: true,
            success: function(data){
              if (data == 'ok'){
                location.reload();
              }else{
                $('#edit_cart_popup').html(data);
                $('.edit_popup').show();
                calc_options_total(pid);
                conditional_rules(pid);             
              }
            }
          });
        });
      }
    }
    if(window.hulkapps.is_product_option || window.hulkapps.is_volume_discount){
      hulkappsStart($);
    }
  }

  window.cartPageJS = function($){
     

    // When user enter the phone_number.
    $('body').on('keypress', '.hulkapps_discount_code', function(e){
      if(e.which == 13){
        $(".hulkapps_discount_button").click();
      }
      if(e.which === 32){
        return false;
      }
    });

    // Button click for Apply Discount.  
    $('body').on('click', '.hulkapps_discount_button', function(e){
      e.preventDefault();
      var code = $('.hulkapps_discount_code').val();
      if(code == ''){
        $('.hulkapps_discount_code').addClass('discount_error');
      }else{
        localStorage.setItem('discount_code', code);
        $('.hulkapps_discount_code').removeClass('discount_error');
        location.reload();
      }
    });

    $('body').on('click', '.close-tag', function(e){
      localStorage.removeItem('discount_code');
      location.reload();
    });

    // When user click on edit_cart save popup.
     $('body').on('click', '.hulkapp_save',function(e){
      e.preventDefault();
      if (validate_options($(this).data('product_id'))) {
        $(checkout_selectors).attr('disabled',true);
        var line = parseInt($(this).parents('.hulkapp_popupBox').find('.hulkapp_mainContent').find('.h_index').val())+1;
        var qty = $(this).attr('data-quantity');
        var line_variant_id = $(this).parents('.hulkapp_popupBox').find('.hulkapp_mainContent').find('.h_variant_id').val();
        let properties = {};
        
        $("#edit_cart_popup [name^='properties']").each(function (index, el) {
          if ($(this).val() == '') {
            $(this).remove();
          }
          let name;
          if (this.type == "radio") {
            if (this.checked) {
              name = this.name.replace('properties[', '').replace(']', '');
              if ($.trim(this.value).length > 0) {
                properties[name] = this.value;
              }
            }
          }else if(this.type == "file"){
            name = this.name.replace('properties[', '').replace(']', '');
            if ($.trim(this.value).length > 0) {
              properties[name] = this.value;
            }
            
          }else {
            name = this.name.replace('properties[', '').replace(']', '');
            if ($.trim(this.value).length > 0) {
              properties[name] = this.value;
            }
          }
          
        });
        
        if ($.isEmptyObject(properties)) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              quantity: 0,
              line: line
            },
            dataType: 'json',
            success: function(cart) {
              
              if($('.upload_cls').val() != ''){
                $('.upload_h_cls').remove();
              }else{
                $('.upload_cls').remove();
              }
              $('#edit_cart_popup .conditional').each(function(index,element){
                $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
              });
              $("[name^='properties']").each(function(index, el) {
                if($(this).val() == ''){
                  $(this).remove();
                }
              });
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  quantity: qty,
                  id: line_variant_id
                },
                dataType: 'json',
                success: function (cart_item) {
                  location.reload();                  
                }
              });
            }
          });
        } else { 
          var formData = new FormData($('#edit_cart_popup')[0]);
          formData.append('quantity', qty);
          formData.append('line', line);
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              quantity: 0,
              line: line
            },
            dataType: 'json',
            success: function(cart) {
              if($('.upload_cls').val() != ''){
                $('.upload_h_cls').remove();
              }else{
                $('.upload_cls').remove();
              }
              $('#edit_cart_popup .conditional').each(function(index,element){
                $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
              });
              $("[name^='properties']").each(function(index, el) {
                if($(this).val() == ''){
                  $(this).remove();
                }
              });
              
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: formData,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (cart_item) {
                  location.reload();                  
                }
              });
            }
          });
        }
      };
    });

    // When edit_cart popup is close.
    $('body').on('click touchstart', '.hulkapp_close', function(e) {
      $('.edit_popup').hide();
      $('body').removeClass('body_fixed');
    });
  }

  window.productPageJS = function($){
    window.conditional_rules = function(prod_id) {
      pass=false;
      verify_all = Array();
      verify_any = Array();
      verified_condition = Array();
      pass_array = Array();
      $("#hulkapps_option_list_" + prod_id + " .condition_hide").removeClass("conditional");
      $("#hulkapps_option_list_" + prod_id + " .condition_show").addClass("conditional");
      $("#hulkapps_custom_options_" + prod_id + " #conditional_rules").children().each(function() {
        pass_array = Array();
        pass=false;
        $(this).children().each(function() {
          pass=false;
          var condition_rule = $(this).text();
          var field_value;
          if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("dd_multi_render") == true) {
            var aa = condition_rule; 
            if (aa.indexOf("!=") >= 0){pass=true;}
            var count = $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").length;
            var ct=1;
            var selected_array = Array();
            if($("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").length > 0){
              $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").each(function(){
                var condition_rule=aa;  
                field_value = $(this).data("conditional-value");
                condition_rule = condition_rule.replace("**value11**", field_value);
                if (condition_rule.indexOf("==") >= 0){
                  var condition_rule = condition_rule.split("==");
                  if (condition_rule[0] == condition_rule[1]) {
                    pass = true;
                  } else {
                    pass = false;
                  }
                }
                else{
                  var condition_rule = condition_rule.split("!=");
                  if (condition_rule[0] != condition_rule[1]) {
                    pass = true;
                  } else {
                    pass = false;
                  }
                }
                selected_array.push(pass);
                if(ct==count && count>1){
                  var result = selected_array.join(' || ');
                  result = eval(result);
                  pass_array.push(result);
                }
                else if(count==1){
                  pass_array.push(pass);
                }
                ct=ct+1;
              });
            }else{
              pass_array.push(false);
            }
          }
          else if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("cb_render") == true) {
            var aa = condition_rule;
            if (aa.indexOf("!=") >= 0){pass=true;}
            var ctt=1;
            var checked_array = Array();
            var countt = $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible:checked").length;
            $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible:checked").each(function() {
              var condition_rule = aa;
              field_value = $(this).data("conditional-value");
              condition_rule = condition_rule.replace("**value11**", field_value);
              if (condition_rule.indexOf("==") >= 0){
                var condition_rule = condition_rule.split("==");
                if (condition_rule[0] == condition_rule[1]) {
                  pass = true;
                }else{
                  pass = false;
                }
              }
              else{
                var condition_rule = condition_rule.split("!=");
                if (condition_rule[0] != condition_rule[1]) {
                  pass = true;
                }else{
                  pass = false;
                }
              } 
              checked_array.push(pass);
              if(ctt==countt && countt>1){
                var result = checked_array.join(' || ');
                result = eval(result);
                pass_array.push(result);
              }
              else if(countt==1){
                pass_array.push(pass);
              }
              ctt=ctt+1;
            });
          } 
          else if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("multiswatch_render") == true) {
            var aa = condition_rule;
            if (aa.indexOf("!=") >= 0){pass=true;}
            var ctt=1;
            var checked_array = Array();
            var countt = $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").length;
            $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").each(function() {
              var condition_rule = aa;
              field_value = $(this).data("conditional-value");
              condition_rule = condition_rule.replace("**value11**", field_value);
              if (condition_rule.indexOf("==") >= 0){
                var condition_rule = condition_rule.split("==");
                if (condition_rule[0] == condition_rule[1]) {
                  pass = true;
                }else{
                  pass = false;
                }
              }
              else{
                var condition_rule = condition_rule.split("!=");
                if (condition_rule[0] != condition_rule[1]) {
                  pass = true;
                }else{
                  pass = false;
                }
              } 
              checked_array.push(pass);
              if(ctt==countt && countt>1){
                var result = checked_array.join(' || ');
                result = eval(result);
                pass_array.push(result);
              }
              else if(countt==1){
                pass_array.push(pass);
              }
              ctt=ctt+1;
            });
          } 
          else { 
            pass=false;
            if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("rb_render") == true) {
              field_value = $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + ":checked").data("conditional-value");
            }
            else if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("dd_render") == true) {
              field_value = $("#hulkapps_option_list_" + prod_id + " #" + $(this).attr("data-field-num") + " option:selected").data("conditional-value");
            } 
            else if ($("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("swatch_render") == true) {
              field_value = $("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num")+ ".swatch_selected").data("conditional-value");
            }else{
              field_value = $("#hulkapps_option_list_" + prod_id + " #" + $(this).attr("data-field-num") + "").val();
            }
            condition_rule = condition_rule.replace("**value11**", field_value);
            if (condition_rule.indexOf("==") >= 0){
              var condition_rule = condition_rule.split("==");
              if (condition_rule[0] == condition_rule[1]) {
                pass = true;
              }else{
                pass = false;
              }
            }else{
              var condition_rule = condition_rule.split("!=");
              if (condition_rule[0] != condition_rule[1]) {
                pass = true;
              }else{
                pass = false;
              }
            }
            pass_array.push(pass);
          }
        });

        var type_rule = $(this).attr("data-verify-all");
        var condition_id = $(this).attr("name");
        if(type_rule=="0"){
          var res = pass_array.join(' || ');
        }
        else{
          var res = pass_array.join(' && ');
        }
        res = eval(res);
        if(res){
          $("#hulkapps_option_list_" + prod_id + " ." + condition_id + "_show").removeClass("conditional");
          $("#hulkapps_option_list_" + prod_id + " ." + condition_id + "_hide").addClass("conditional");
          $("#hulkapps_option_list_" + prod_id + " ." + condition_id + "_hide.conditional").find('.hulkapps_option_child').each(function() {
            conditional_change($(this));
          });
        }
        else{
          $("#hulkapps_option_list_" + prod_id + " ." + condition_id + "_show.conditional").find('.hulkapps_option_child').each(function() {
            conditional_change($(this));
          });
        }
        });
        calc_options_total(prod_id);
      // border_bottom = $(".hulkapps_option:visible").css("border-bottom");
      // $(".hulkapps_option:visible").css("border-bottom",border_bottom);
      // $(".hulkapps_option:visible:last").css("border-bottom","none");
    }
    window.conditional_change = function(obj){
      if (obj.prop("type") == "select-one" || obj.prop("type") == "select-multiple") {
        if (obj.val()){
          obj.val('').change();
        }
      }
      else if (obj.prop("type") == "radio") {
        if (obj.prop("checked")){
          obj.prop("checked", false);
          obj.val('');
          obj.parent().find('.radio_selected').removeClass("radio_selected");
        }
      }
      else if (obj.prop("type") == "textarea" || obj.prop("type") == "text" || obj.prop("type") == "hidden" || obj.prop("type") == "file" || obj.prop("type") == "email" || obj.prop("type") == "date_picker"){
        if (obj.val()){
          obj.val('').change();
          obj.parents('.hulkapps_option_value').find('.tb_property_val').val('');
          obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
        }
      }
      else if (obj.prop("type") == "checkbox") {
        if (obj.prop("checked")){
          obj.prop("checked", false);
          obj.parent().removeClass("swatch_selected");
        }
      }
      else if (obj.prop("tagName") == "DIV") {
        if (obj.find('.swatch_radio').prop("checked")){
          obj.find('.swatch_radio').prop("checked", false);
          obj.removeClass("swatch_selected");
        }
      }
    }
    window.calc_options_total = function(product_id) {
      var i;
      var total = 0;
      var format = window.hulkapps.money_format;

      checked_variant = $("#hulkapps_option_list_" + product_id + ":visible .price-change:checked, #hulkapps_option_list_" + product_id + ":visible .price-change:selected, .hulkapps_swatch_option .swatch_selected,.textarea_selected,.textbox_selected,.emailbox_selected,.datepicker_selected,.numberfield_selected");
      for (i = 0; i < checked_variant.length; i++) {
        if(!$(checked_variant[i]).parents(".hulkapps_option").hasClass('conditional')){
          total = Number($(checked_variant[i]).attr("data-price")) + Number(total);
        }
      }
      $("#hulkapps_options_" + product_id + " #raw_option_total").val(total);
      $("#hulkapps_options_" + product_id + " #calculated_option_total").html(total.toFixed(2));
      if (total > 0 && 1) {
        $('#hulkapps_options_' + product_id + ' #option_total').slideDown();
      }else{
        $('#hulkapps_options_' + product_id + ' #option_total').slideUp();
      }
    } 

    window.check_character_limit = function(chartotal,product_id,remain_char_msg) {
      var text_length = $('.hulkapps_option_value .hulkapps_option_'+product_id+'').val().length;
      var text_remaining = chartotal - text_length;
      $('#char_count_'+product_id+'').html(text_remaining + ' ' + remain_char_msg);
    }          
    window.validate_options = function(product_id) {
      var good = true;
      $(".hulkapps_option:visible").each(function() {
        if ($(this).hasClass("validation_error")) {
          good=false;
        }
      });
      $('#hulkapps_options_' + product_id + ' #error_text').html('');
      var hulkapps_req = $("#hulkapps_option_list_" + product_id + ":visible .required:visible");
      var i;
      for (i = 0; i < hulkapps_req.length; i++) {
        if ($(hulkapps_req[i]).find("select[name^='properties']").length == 1 && !$(hulkapps_req[i]).find("select[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find(".hulkapps_radio_option").length && !$(hulkapps_req[i]).find("input[name^='properties']:checked").length) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        }
        else if ($(hulkapps_req[i]).find(".hulkapps_swatch_option").length && !$(hulkapps_req[i]).find("input[name^='properties']:checked").length) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find("input[type='text']").length > 1) {
          $(hulkapps_req[i]).find("input[type='text']").each(function(){
            if($(this).val() == ''){
              $(hulkapps_req[i]).addClass("validation_error");  
              good = false;
            }
          });
        } else if ($(hulkapps_req[i]).find("input[type='text']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        }
        else if ($(hulkapps_req[i]).find("input[type='email']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()){
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find(".hulkapps_check_option").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find("input[type='file']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).hasClass("cb_render") && $(hulkapps_req[i]).find("input[type='checkbox']:checked").length && !$(hulkapps_req[i]).find("input[name^='properties']").length) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).hasClass("multiswatch_render") && $(hulkapps_req[i]).find("input[type='checkbox']:checked").length && !$(hulkapps_req[i]).find("input[name^='properties']").length) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find("textarea").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else if ($(hulkapps_req[i]).find("input[type='number']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;

        } else if ($(hulkapps_req[i]).hasClass("dp_render") && $(hulkapps_req[i]).find("input[type='text']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;  
        } else if ($(hulkapps_req[i]).find("select[multiple]").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
          $(hulkapps_req[i]).addClass("validation_error");
          good = false;
        } else {
          $(hulkapps_req[i]).removeClass("validation_error");
        }
      }

      $("#hulkapps_option_list_" + product_id + " .cb_render:visible").each(function(){
        if($(this).hasClass('required')){
          if ($(this).find("input[type='checkbox']").length){
            if ($(this).find("input[name^='properties']").val()){
              if ($(this).find('.error_span').length > 0){
                $(this).addClass("validation_error");
                good=false;
              }else{
                $(this).removeClass("validation_error");
              }
            }else{
              $(this).addClass("validation_error");
              good=false;
            }
          }else{
            if ($(this).find('.error_span').length > 0){
              $(this).addClass("validation_error");
              good=false;
            }else{
              $(this).removeClass("validation_error");
            }
          }
        }else{
          if ($(this).find('.error_span').length > 0){
            $(this).addClass("validation_error");
            good=false;
          }else{
            $(this).removeClass("validation_error");
          }
        }
      });
      $("#hulkapps_option_list_" + product_id + " .multiswatch_render:visible").each(function(){
        if($(this).hasClass('required')){
          if ($(this).find("input[type='checkbox']").length){
            if ($(this).find("input[name^='properties']").val()){
              if ($(this).find('.error_span').length > 0){
                $(this).addClass("validation_error");
                good=false;
              }else{
                $(this).removeClass("validation_error");
              }
            }else{
              $(this).addClass("validation_error");
              good=false;
            }
          }else{
            if ($(this).find('.error_span').length > 0){
              $(this).addClass("validation_error");
              good=false;
            }else{
              $(this).removeClass("validation_error");
            }
          }
        }else{
          if ($(this).find('.error_span').length > 0){
            $(this).addClass("validation_error");
            good=false;
          }else{
            $(this).removeClass("validation_error");
          }
        }
      });

      $("#hulkapps_option_list_" + product_id+ " .dd_multi_render:visible").each(function(){
        if($(this).hasClass('required')){
          if ($(this).find("select[multiple]").length){
            if ($(this).find("input[name^='properties']").val()){
              if ($(this).find('.error_span').length > 0){
                $(this).addClass("validation_error");
                good=false;
              }else{
                $(this).removeClass("validation_error");
              }
            }else{
              $(this).addClass("validation_error");
              good=false;
            }
          }else{
            if ($(this).find('.error_span').length > 0){
              $(this).addClass("validation_error");
              good=false;
            }else{
              $(this).removeClass("validation_error");
            }
          }
        }else{
          if ($(this).find('.error_span').length > 0){
            $(this).addClass("validation_error");
            good=false;
          }else{
            $(this).removeClass("validation_error");
          }
        }
      });
      $("#hulkapps_option_list_" + product_id + " .et_render.required:visible").each(function(){
        if ($(this).find("input[type='email']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')) || (($(this).find("input[type='email']").val()) != ''))){
          var userEmail = $(this).find("input[type='email']").val();
          var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
          if (!filter.test(userEmail)) {
            $(this).addClass("validation_error");
            good=false;
          }
          else {
            $(this).removeClass("validation_error");
          }
        }
      });
      $("#hulkapps_option_list_" + product_id + " .pn_render.required:visible").each(function(){
        if($(this).find("input[type='textbox']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')))){
          $(this).addClass("validation_error");
          good=false;
        }else{
          if($(this).find(".phone_number").hasClass('error')){
            $(this).addClass("validation_error");
            good=false;
          }else{
            $(this).removeClass("validation_error");
          }
        }
      });
      $("#hulkapps_option_list_" + product_id + " .dp_render:visible").each(function(){
        if ($(this).find('.error_span').length > 0){
            $(this).addClass("validation_error");
            good=false;
        }else{
            $(this).removeClass("validation_error");
        }
      });
      $("#hulkapps_option_list_" + product_id + " .dp_render.required:visible").each(function(){
        if($(this).find("input[type='text']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')))){
          $(this).addClass("validation_error");
          good=false;
        }else{
          if($(this).find('.error_span').length > 0){
            $(this).addClass("validation_error");
            good=false;
          }else{
            $(this).removeClass("validation_error");
          }
        }
      });
      
      return good;
    }
    window.validate_single_option = function(option_type_id,option_type) {
      if(option_type == 'dd_render'){
        if ($('.'+option_type_id).find("select[name^='properties']").length == 1 && !$('.'+option_type_id).find("select[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else{
          $('.'+option_type_id).removeClass("validation_error");
        }
      }

      else if(option_type == 'dd_multi_render'){
        if ($('.'+option_type_id).find("select[multiple]").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else{
          $('.'+option_type_id).removeClass("validation_error");
        }
      }

      else if(option_type == 'swatch_render'){
        // if ($('.'+option_type_id).find(".hulkapps_swatch_option").length && !$('.'+option_type_id).find("input[name^='properties']:checked").length && $('.'+option_type_id).hasClass('required')) {
        //   $('.'+option_type_id).addClass("validation_error");
        // }else {
          $('.'+option_type_id).removeClass("validation_error");
        // }
      }
      else if(option_type == 'multiswatch_render'){
        if ($('.'+option_type_id).find(".hulkapps_swatch_option").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }  
      else if(option_type == 'cb_render'){
        if ($('.'+option_type_id).find(".hulkapps_check_option").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }

      else if(option_type == 'tb_render'){
        if ($('.'+option_type_id).find("input[type='text']").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }
      else if(option_type == 'nf_render'){
        if ($('.'+option_type_id).find("input[type='number']").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }
      else if(option_type == 'dp_render'){
        if ($('.'+option_type_id).find("input[type='text']").length && $('.'+option_type_id).find("input[name^='properties']").val()){
          var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; //Declare Regex
          var dtArray = $('.'+option_type_id).find("input[type='text']").val().match(rxDatePattern);    // is format OK?
          if (dtArray == null){
            $('.'+option_type_id).addClass("validation_error");
            $('.'+option_type_id).find('.validation_error').remove();
            $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>');
          }else{ 
            //Checks for mm/dd/yyyy format.
            dtMonth = dtArray[1];
            dtDay= dtArray[3];
            dtYear = dtArray[5]; 
            if (dtMonth < 1 || dtMonth > 12){
              $('.'+option_type_id).addClass("validation_error");
              $('.'+option_type_id).find('.validation_error').remove();
              $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>')
            }else if (dtDay < 1 || dtDay> 31){ 
              $('.'+option_type_id).addClass("validation_error");
              $('.'+option_type_id).find('.validation_error').remove();
              $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>')
            }else if ((dtMonth==4 || dtMonth==6 || dtMonth==9 || dtMonth==11) && dtDay ==31){
              $('.'+option_type_id).addClass("validation_error");
              $('.'+option_type_id).find('.validation_error').remove();
              $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>')
            }else if (dtMonth == 2){
              var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
              if (dtDay> 29 || (dtDay ==29 && !isleap)){
                $('.'+option_type_id).addClass("validation_error");
                $('.'+option_type_id).find('.validation_error').remove();
                $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>')
              }else{
                $('.'+option_type_id).removeClass("validation_error");
                $('.'+option_type_id).find('.validation_error').remove();
              }
            }else if (dtArray[2] !== "/" || dtArray[4] !== "/"){
                $('.'+option_type_id).addClass("validation_error");
                $('.'+option_type_id).find('.validation_error').remove();
                $('.'+option_type_id).find("input[type='text']").after('<span class="validation_error error_span">Enter valid date format mm/dd/yyyy</span>')
            }else{
              $('.'+option_type_id).removeClass("validation_error");
              $('.'+option_type_id).find('.validation_error').remove();
            }
          }
        }else{
          if ($('.'+option_type_id).find("input[type='text']").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
            $('.'+option_type_id).addClass("validation_error");
            $('.'+option_type_id).find('.validation_error').remove();
          }
          else {
            $('.'+option_type_id).find('.validation_error').remove();
            $('.'+option_type_id).removeClass("validation_error");
          }
        }
      }

      else if(option_type == 'ta_render'){
        if ($('.'+option_type_id).find("textarea").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }

      else if(option_type == 'rb_render'){
        // if ($('.'+option_type_id).find(".hulkapps_radio_option").length && !$('.'+option_type_id).find("input[name^='properties']:checked").length && $('.'+option_type_id).hasClass('required')) {
        //   $('.'+option_type_id).addClass("validation_error");
        // }else {
          $('.'+option_type_id).removeClass("validation_error");
        // }
      }

      else if(option_type == 'fu_render'){
        if ($('.'+option_type_id).find("input[type='file']").length && !$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) {
          $('.'+option_type_id).addClass("validation_error");
        }else {
          $('.'+option_type_id).removeClass("validation_error");
        }
      }

      else if(option_type == 'pn_render'){
        if($('.'+option_type_id).find("input[type='textbox']").length && ((!$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')))){
          $('.'+option_type_id).addClass("validation_error");
          good=false;
        }else{
          if($('.'+option_type_id).find(".phone_number").hasClass('error')){
            $('.'+option_type_id).addClass("validation_error");
            good=false;
          }else{
            $('.'+option_type_id).removeClass("validation_error");
          }
        }
      }

      else if(option_type == 'et_render'){
        if ($('.'+option_type_id).find("input[type='email']").length && ((!$('.'+option_type_id).find("input[name^='properties']").val() && $('.'+option_type_id).hasClass('required')) || (($('.'+option_type_id).find("input[type='email']").val().length) != ''))){
          var userEmail = $('.'+option_type_id).find("input[type='email']").val();
          var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
          if (!filter.test(userEmail)) {
            $('.'+option_type_id).addClass("validation_error");
          }else{
            $('.'+option_type_id).removeClass("validation_error");
          }
        }else{
          $('.'+option_type_id).removeClass("validation_error");
        }
      }
    }
    var hulk_flag = 0;
    $("body").on('click', '.hulkapps_submit_cart', function(e) {  
      if(hulk_flag == 0){
        e.preventDefault();
        var res = true;
        if (validate_options(window.hulkapps.product_id)) {
          $("[name^='properties']").each(function(){
            if($(this).val() == ''){
              $(this).attr('disabled',true);
            }
          });
          hulk_flag = 1;
          $('.hulkapps_submit_cart').click();
        }
      };
    });
  }
  
  window.writeCookie = function(cName,cVal,cExpMin) {
    cExpMin = cExpMin || 0;
    newDate = new Date;
    deleteCookie(cName);
      var date = new Date();
      date.setTime(date.getTime()+(cExpMin*60*1000));
      var expires = "; expires="+date.toGMTString();
      document.cookie = cName+"="+encodeURIComponent(cVal)+";expires="+date.toGMTString()+";path=/; samesite=none; secure"
  }

  window.readCookie = function(cname){
    var name = cname + "=";
    var ca = decodeURI(document.cookie);
    // var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  window.deleteCookie = function(name){
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=none; secure';
  }
}

start();
if (typeof window.hulkapps !== 'undefined'){
  if ((typeof(jQuery) == 'undefined') || (parseInt(jQuery.fn.jquery) == 3 && parseFloat(jQuery.fn.jquery.replace(/^1\./,"")) < 2.1)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js', function() {
      jQuery321 = jQuery.noConflict(true);
      checkAppInstalled(jQuery321);
    });
  }else{ 
    checkAppInstalled(jQuery);
  }
}